﻿package com.mgacreative.hotelru.feature.admin.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.mgacreative.hotelru.domain.model.Supplier
import com.mgacreative.hotelru.domain.model.SupplierCategory
import com.mgacreative.hotelru.domain.repository.SupplierRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class AdminSupplierViewModel(
    private val supplierRepository: SupplierRepository
) : ViewModel() {

    private val _categories = MutableStateFlow<List<SupplierCategory>>(emptyList())
    val categories: StateFlow<List<SupplierCategory>> = _categories.asStateFlow()

    private val _suppliers = MutableStateFlow<List<Supplier>>(emptyList())
    val suppliers: StateFlow<List<Supplier>> = _suppliers.asStateFlow()

    private val _isLoading = MutableStateFlow(false)
    val isLoading: StateFlow<Boolean> = _isLoading.asStateFlow()

    init {
        loadData()
    }

    fun loadData() {
        viewModelScope.launch {
            _isLoading.value = true
            _categories.value = supplierRepository.getCategories()
            _suppliers.value = supplierRepository.getSuppliers()
            _isLoading.value = false
        }
    }

    fun addCategory(name: String) {
        viewModelScope.launch {
            supplierRepository.createCategory(SupplierCategory(name = name))
            loadData()
        }
    }

    fun deleteCategory(id: String) {
        viewModelScope.launch {
            supplierRepository.deleteCategory(id)
            loadData()
        }
    }

    fun addSupplier(categoryId: String, name: String, contactInfo: String) {
        viewModelScope.launch {
            supplierRepository.createSupplier(
                Supplier(
                    category_id = categoryId,
                    name = name,
                    contact_info = contactInfo
                )
            )
            loadData()
        }
    }

    fun deleteSupplier(id: String) {
        viewModelScope.launch {
            supplierRepository.deleteSupplier(id)
            loadData()
        }
    }
}

